import Immutable from 'immutable'
import moment from 'moment'

import createAccounting from './Accounting'
import createAuthentication from './Authentication'
import createExtra from './Extra'
import createHostedMail from './HostedMail'
import createIpn from './Ipn'
import createRestriction from './Restriction'
import createServiceDefinition from './ServiceDefinition'
import createSharedHosting from './SharedHosting'
import createSsl from './Ssl'
import createSupplier from './Supplier'
import createTransit from './Transit'

export { AccountingRecord } from './Accounting'
export { AuthenticationRecord } from './Authentication'
export { ExtraRecord } from './Extra'
export { HostedMailRecord } from './HostedMail'
export { IpnRecord } from './Ipn'
export { RestrictionRecord } from './Restriction'
export { ServiceDefinitionRecord } from './ServiceDefinition'
export { SharedHostingRecord } from './SharedHosting'
export { SslRecord } from './Ssl'
export { SupplierRecord } from './Supplier'
export { TransitRecord } from './Transit'

export const ServiceRecord = Immutable.Record({
  accounting: null,
  authentication: null,
  billingGroupId: null,
  clientId: null,
  coupon: null,
  couponExpiry: null,
  dateAdded: null,
  dateStarted: null,
  dateTerminated: null,
  dateUpdated: null,
  extras: null,
  hostedMail: null,
  id: null,
  identifier: '',
  ipn: null,
  offerId: null,
  reference: '',
  restrictions: null,
  service: null,
  sharedHosting: null,
  siteId: null,
  ssl: null,
  supplier: null,
  transit: null,
}, 'Service')

export default function createService({
  accounting,
  authentication,
  billing_group,
  coupon,
  couponExpiry,
  client_id,
  date_added,
  date_started,
  date_terminated,
  date_updated,
  extras = [],
  hosted_mail,
  ipn,
  offer,
  restrictions = [],
  service,
  shared_hosting,
  site,
  ssl,
  supplier,
  transit,
  ...data
}) {
  /* eslint-disable camelcase */
  return new ServiceRecord({
    accounting: createAccounting(accounting),
    authentication: authentication ? createAuthentication(authentication) : null,
    billingGroupId: billing_group ? billing_group.id : null,
    clientId: client_id,
    coupon: coupon ? coupon.id : null,
    couponExpiry: couponExpiry ? moment(couponExpiry) : null,
    dateAdded: date_added ? moment(date_added) : null,
    dateStarted: date_started ? moment(date_started) : null,
    dateTerminated: date_terminated ? moment(date_terminated) : null,
    dateUpdated: date_updated ? moment(date_updated) : null,
    extras: Immutable.Set(extras.map(e => createExtra(e))),
    hostedMail: hosted_mail ? createHostedMail(hosted_mail) : null,
    ipn: ipn ? createIpn(ipn) : null,
    offerId: offer ? offer.id : null,
    restrictions: Immutable.Set(restrictions.map(r => createRestriction(r))),
    service: createServiceDefinition(service),
    sharedHosting: shared_hosting ? createSharedHosting(shared_hosting) : null,
    siteId: site ? site.id : null,
    ssl: ssl ? createSsl(ssl) : null,
    supplier: supplier ? createSupplier(supplier) : null,
    transit: transit ? createTransit(transit) : null,
    ...data,
  })
  /* eslint-enable camelcase */
}

function activeRestriction(restriction, now) {
  return !restriction.expires || restriction.expires.isAfter(now)
}

export function isRestricted(service, type, now) {
  return service.restrictions.some(r => r.type === type && activeRestriction(r, now))
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/index.js